import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            change: {
                'select': 'changeFilter'
            }
        }
    }

    init() {

    }

    changeFilter(e) {
        let value = e.curTarget.value;
        let url =  window.location.pathname + "?sort_by=" + value

        this.call('goTo', [url, 'filter'], 'Load')
    }
}
